import { useEffect } from "react";
import { CircularProgress, Stack, } from "@mui/material";
import { useAppSelector, useAppDispatch } from "@/hooks";
import { useLazyFetchAccessQuery } from "@/api/accessApi";
import { useLazyFetchUserOrganizationsQuery } from "../organizations/api/organizationsApi";
import useRoutes from "@/hooks/useRoutes";
import { setActiveOrganization } from "@/store/uiSlice";

const Organizations = () => {
  const [navigate] = useRoutes();
  const dispatch = useAppDispatch();
  const uid = useAppSelector((state) => state?.auth?.user?.uid);
  const [fetchAccess, access] = useLazyFetchAccessQuery();
  const [fetchOrganizations, organizations] = useLazyFetchUserOrganizationsQuery();

  const getInitialData = async (uid: string) => {
    const access = await fetchAccess(uid);

    if (!access?.data || access.data.length === 0) {
      navigate('organizations.create');
      return;
    }

    const organizations = await fetchOrganizations(access.data);

    if (!organizations?.data || organizations.data.length === 0) {
      navigate('organizations.create');
      return;
    }

    const firstOrganization = organizations.data[0];

    dispatch(setActiveOrganization(firstOrganization.id));

    navigate('organizations.firstSteps.main', {
      organizationId: firstOrganization.id,
    });
  }

  useEffect(() => {
    if (uid) {
      getInitialData(uid);
    }
  }, [uid]);

  if (access.isFetching || organizations.isFetching) {
    return (
      <Stack flex={1} direction="row" alignItems="center" justifyContent="center" padding={4}>
        <CircularProgress />
      </Stack>
    );
  }

  return null;
};

export default Organizations;
